export default "__VITE_ASSET__p$Sp0L3T__"